import { PAC_FORM_TYPES } from "social/constants/common";
import { SOCIAL_AD_TYPES } from "utils/constants";

// FT Formats
import FacebookImageDefaultPlacement from "../formats/FacebookImage/placements/Default";
import FacebookImageSquarePlacement from "../formats/FacebookImage/placements/Square/form";
import FacebookImageHorizontalPlacement from "../formats/FacebookImage/placements/Horizontal/form";
import FacebookImageVerticalPlacement from "../formats/FacebookImage/placements/Vertical/form";

import FacebookVideoDefaultPlacement from "../formats/FacebookVideo/placements/Default";
import FacebookVideoSquarePlacement from "../formats/FacebookVideo/placements/Square/form";
import FacebookVideoHorizontalPlacement from "../formats/FacebookVideo/placements/Horizontal/form";
import FacebookVideoVerticalPlacement from "../formats/FacebookVideo/placements/Vertical/form";

// Image MO Formats
import FacebookImageMODefaultPlacement from "../formats/FacebookImageMO/placements/Default";
import FacebookImageMOSquarePlacement from "../formats/FacebookImageMO/placements/Square/form";
import FacebookImageMOHorizontalPlacement from "../formats/FacebookImageMO/placements/Horizontal/form";
import FacebookImageMOVerticalPlacement from "../formats/FacebookImageMO/placements/Vertical/form";
import FacebookImageMOLegacyReelsPlacement from "../formats/FacebookImageMO/placements/LegacyReels/form";

import FacebookImageMOFBStoriesPlacement from "../formats/FacebookImageMO/placements/FacebookStories/form";
import FacebookImageMOFBFeedsPlacement from "../formats/FacebookImageMO/placements/FacebookFeeds/form";
import FacebookImageMOFBReelsPlacement from "../formats/FacebookImageMO/placements/FacebookReels/form";
import FacebookImageMOFBInStreamVideoPlacement from "../formats/FacebookImageMO/placements/FacebookInStreamVideo/form";

import FacebookImageMOIGFeedsPlacement from "../formats/FacebookImageMO/placements/InstagramFeeds/form";
import FacebookImageMOIGReelsPlacement from "../formats/FacebookImageMO/placements/InstagramReels/form";
import FacebookImageMOIGProfileReelsPlacement from "../formats/FacebookImageMO/placements/InstagramProfileReels/form";
import FacebookImageMOIGStoriesPlacement from "../formats/FacebookImageMO/placements/InstagramStories/form";
import FacebookImageMOIGExplorePlacement from "../formats/FacebookImageMO/placements/InstagramExplore/form";
import FacebookImageMOIGExploreHomePlacement from "../formats/FacebookImageMO/placements/InstagramExploreHome/form";

// Video MO Formats
import FacebookVideoMODefaultPlacement from "../formats/FacebookVideoMO/placements/Default";
import FacebookVideoMOSquarePlacement from "../formats/FacebookVideoMO/placements/Square/form";
import FacebookVideoMOHorizontalPlacement from "../formats/FacebookVideoMO/placements/Horizontal/form";
import FacebookVideoMOVerticalPlacement from "../formats/FacebookVideoMO/placements/Vertical/form";
import FacebookVideoMOLegacyReelsPlacement from "../formats/FacebookVideoMO/placements/LegacyReels/form";

import FacebookVideoMOFBStoriesPlacement from "../formats/FacebookVideoMO/placements/FacebookStories/form";
import FacebookVideoMOFBFeedsPlacement from "../formats/FacebookVideoMO/placements/FacebookFeeds/form";
import FacebookVideoMOFBReelsPlacement from "../formats/FacebookVideoMO/placements/FacebookReels/form";
import FacebookVideoMOFBInStreamVideoPlacement from "../formats/FacebookVideoMO/placements/FacebookInStreamVideo/form";

import FacebookVideoMOIGFeedsPlacement from "../formats/FacebookVideoMO/placements/InstagramFeeds/form";
import FacebookVideoMOIGReelsPlacement from "../formats/FacebookVideoMO/placements/InstagramReels/form";
import FacebookVideoMOIGProfileReelsPlacement from "../formats/FacebookVideoMO/placements/InstagramProfileReels/form";
import FacebookVideoMOIGStoriesPlacement from "../formats/FacebookVideoMO/placements/InstagramStories/form";
import FacebookVideoMOIGExplorePlacement from "../formats/FacebookVideoMO/placements/InstagramExplore/form";
import FacebookVideoMOIGExploreHomePlacement from "../formats/FacebookVideoMO/placements/InstagramExploreHome/form";

const FACEBOOK_IMAGE_PAC_FIELDS = {
	[PAC_FORM_TYPES.SQUARE]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.VERTICAL]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.HORIZONTAL]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
};

const FACEBOOK_IMAGE_MO_PAC_FIELDS = {
	[PAC_FORM_TYPES.SQUARE]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.VERTICAL]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.HORIZONTAL]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.REELS]: [
		"image",
		"primaryText",
		"landingPage",
	],

	[PAC_FORM_TYPES.FB_STORIES]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.FB_FEEDS]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.FB_REELS]: [
		"image",
		"primaryText",
		"landingPage",
	],

	[PAC_FORM_TYPES.IG_FEEDS]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.IG_REELS]: [
		"image",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.IG_EXPLORE_HOME]: [
		"image",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.IG_PROFILE_REELS]: [
		"image",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.IG_STORIES]: [
		"image",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.IG_EXPLORE]: [
		"image",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.FB_INSTREAM]: [
		"image",
		"headline",
		"primaryText",
		"landingPage",
	],
};

const FACEBOOK_VIDEO_PAC_FIELDS = {
	[PAC_FORM_TYPES.SQUARE]: [
		"video",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.VERTICAL]: [
		"video",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.HORIZONTAL]: [
		"video",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
};

const FACEBOOK_VIDEO_MO_PAC_FIELDS = {
	[PAC_FORM_TYPES.SQUARE]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.VERTICAL]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.HORIZONTAL]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.REELS]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
	],

	[PAC_FORM_TYPES.FB_STORIES]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.FB_FEEDS]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.FB_REELS]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
	],

	[PAC_FORM_TYPES.IG_FEEDS]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
		"displayLink",
	],
	[PAC_FORM_TYPES.IG_REELS]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.IG_EXPLORE_HOME]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.IG_PROFILE_REELS]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.IG_STORIES]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.IG_EXPLORE]: [
		"video",
		"thumbnail",
		"primaryText",
		"landingPage",
	],
	[PAC_FORM_TYPES.FB_INSTREAM]: [
		"video",
		"thumbnail",
		"headline",
		"primaryText",
		"landingPage",
	],
};

export const PAC_FIELDS_BY_AD_TYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: FACEBOOK_IMAGE_PAC_FIELDS,
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: FACEBOOK_IMAGE_MO_PAC_FIELDS,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: FACEBOOK_VIDEO_PAC_FIELDS,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: FACEBOOK_VIDEO_MO_PAC_FIELDS,
};

export const PAC_SELECT_DISABLED_VERSIONS_MESSAGE = "Aspect ratios cannot be added or removed once the creative has versions";

export const PAC_FORMS_BY_ADTYPE_AND_PLACEMENT = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: {
		[PAC_FORM_TYPES.DEFAULT]: FacebookImageDefaultPlacement,
		[PAC_FORM_TYPES.SQUARE]: FacebookImageSquarePlacement,
		[PAC_FORM_TYPES.HORIZONTAL]: FacebookImageHorizontalPlacement,
		[PAC_FORM_TYPES.VERTICAL]: FacebookImageVerticalPlacement,
	},
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: {
		[PAC_FORM_TYPES.DEFAULT]: FacebookVideoDefaultPlacement,
		[PAC_FORM_TYPES.SQUARE]: FacebookVideoSquarePlacement,
		[PAC_FORM_TYPES.HORIZONTAL]: FacebookVideoHorizontalPlacement,
		[PAC_FORM_TYPES.VERTICAL]: FacebookVideoVerticalPlacement,
	},
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: {
		[PAC_FORM_TYPES.DEFAULT]: FacebookImageMODefaultPlacement,
		[PAC_FORM_TYPES.SQUARE]: FacebookImageMOSquarePlacement,
		[PAC_FORM_TYPES.HORIZONTAL]: FacebookImageMOHorizontalPlacement,
		[PAC_FORM_TYPES.VERTICAL]: FacebookImageMOVerticalPlacement,
		[PAC_FORM_TYPES.REELS]: FacebookImageMOLegacyReelsPlacement,

		[PAC_FORM_TYPES.FB_STORIES]: FacebookImageMOFBStoriesPlacement,
		[PAC_FORM_TYPES.FB_FEEDS]: FacebookImageMOFBFeedsPlacement,
		[PAC_FORM_TYPES.FB_REELS]: FacebookImageMOFBReelsPlacement,
		[PAC_FORM_TYPES.FB_INSTREAM]: FacebookImageMOFBInStreamVideoPlacement,

		[PAC_FORM_TYPES.IG_FEEDS]: FacebookImageMOIGFeedsPlacement,
		[PAC_FORM_TYPES.IG_REELS]: FacebookImageMOIGReelsPlacement,
		[PAC_FORM_TYPES.IG_PROFILE_REELS]: FacebookImageMOIGProfileReelsPlacement,
		[PAC_FORM_TYPES.IG_STORIES]: FacebookImageMOIGStoriesPlacement,
		[PAC_FORM_TYPES.IG_EXPLORE]: FacebookImageMOIGExplorePlacement,
		[PAC_FORM_TYPES.IG_EXPLORE_HOME]: FacebookImageMOIGExploreHomePlacement,
	},
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: {
		[PAC_FORM_TYPES.DEFAULT]: FacebookVideoMODefaultPlacement,
		[PAC_FORM_TYPES.SQUARE]: FacebookVideoMOSquarePlacement,
		[PAC_FORM_TYPES.HORIZONTAL]: FacebookVideoMOHorizontalPlacement,
		[PAC_FORM_TYPES.VERTICAL]: FacebookVideoMOVerticalPlacement,
		[PAC_FORM_TYPES.REELS]: FacebookVideoMOLegacyReelsPlacement,

		[PAC_FORM_TYPES.FB_STORIES]: FacebookVideoMOFBStoriesPlacement,
		[PAC_FORM_TYPES.FB_FEEDS]: FacebookVideoMOFBFeedsPlacement,
		[PAC_FORM_TYPES.FB_REELS]: FacebookVideoMOFBReelsPlacement,
		[PAC_FORM_TYPES.FB_INSTREAM]: FacebookVideoMOFBInStreamVideoPlacement,

		[PAC_FORM_TYPES.IG_FEEDS]: FacebookVideoMOIGFeedsPlacement,
		[PAC_FORM_TYPES.IG_REELS]: FacebookVideoMOIGReelsPlacement,
		[PAC_FORM_TYPES.IG_PROFILE_REELS]: FacebookVideoMOIGProfileReelsPlacement,
		[PAC_FORM_TYPES.IG_STORIES]: FacebookVideoMOIGStoriesPlacement,
		[PAC_FORM_TYPES.IG_EXPLORE]: FacebookVideoMOIGExplorePlacement,
		[PAC_FORM_TYPES.IG_EXPLORE_HOME]: FacebookVideoMOIGExploreHomePlacement,
	},
};
